import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Setting } from 'src/app/constants/setting';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingApiService {
  baseURL = `${environment.baseURL}${environment.projectServiceEndPoint}`;

  constructor(private httpClient: HttpClient) {}

  getGlobalSettings(): Observable<Setting[]> {
    return this.httpClient.get<Setting[]>(`${this.baseURL}/global/setting/list`);
  }

  postGlobalSettings(data: any): Observable<any> {
    const body = [
      {
        id: 2,
        settingValue: data,
      },
    ];
    return this.httpClient.put<any>(`${this.baseURL}/global/setting/update-settings`, body);
  }
}
